import { RedirectTiresetToCarModel } from "./redirectTiresetToCarModel";
import { Navigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/useTypedSelector";
import { useEffect, useState } from "react";
import { QrTireSetResponseModel } from "../../../../qrcode/domain/model/qrResponseModel";
import { getTireset } from "../../../../tireset/infrastructure/slices/tireSetMutateSlice";

export const RedirectTiresetToCar = ({ id }: RedirectTiresetToCarModel) => {
  const dispatch = useAppDispatch();
  const [tireset, setTireset] = useState<QrTireSetResponseModel | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const result = await dispatch(getTireset(id));

      setTireset(result.payload as QrTireSetResponseModel);
    };

    void fetchData();
  }, [id, dispatch]);

  if (!tireset) {
    return <>Loading...</>;
  }
  return <Navigate to={`/car/${tireset.car.id}/edit`} />;
};
